<template>
<div class="chapter">
<div class="inner_page">
      ﻿






<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>The Angel
Answer Book</title>
<p class="ser1" id="pAah"><span id="aa_2"><img alt="images/img-5-1.jpg" id="Aah" src="images/img-5-1.jpg"/></span></p>
<p class="ct" id="pAYB">
<a href="#/contents#bb_2"><span style="color:#007467;">Introduction<br/> All Night, All Day</span></a> </p>
<p class="tx1" id="pArF">
<span class="dcap" style="color:#007467;">W</span>hen my friend Richard Hendrix was ten years old, he lived in the small coal mining town
of Carbon Hill, Alabama. The Hendrix home sat on the edge of a forest and had a spanning
porch where his mother and grandmother worked peeling apples or snapping beans.
Richard loved to play with his friends in the nearby woods, especially around a large,
overturned pine tree. </p>
<p class="tx" id="pAqL">
One day, as the family sat on the porch, a stranger approached. Since Carbon Hill
was a small town, everyone knew the neighbors. The man, however, was unknown to
them. He displayed Native American features and was toting a rifle. He asked if he
could walk around and hunt snakes. </p>
<p class="tx" id="pAAp">
“Mama ordinarily would have told him to come back when Dad was home,” Richard told
me, “but for some reason she gave him permission. It <span id="A9U">seemed as though he belonged
there; we felt safe in his presence.” </span></p>
<p class="tx" id="pAAc">
The stranger walked straight down to the fallen pine tree as though he knew where
he was going. It was a distance away, out of sight from the house, and no one had
mentioned the spot to him. But a few moments later, the air cracked with rifle shots.
Shortly, the stranger reappeared with three large rattlesnakes. The largest had twenty
rattlers. He had shot them where the children would soon have been playing. The man
turned and walked back down the road and was never seen again. </p>
<p class="tx" id="pAlF">
“We asked about him,” said Richard, “but nobody knew him, and nobody in the neighborhood
saw him come or go. If any of us had been bitten by one of the snakes, we wouldn’t
have survived long enough to get to the hospital twenty miles away. I’ve always wondered
if it was a coincidence, or if we saw an angel without realizing it. I might not
be alive today if not for this mysterious stranger showing up unannounced at our
house that summer day in 1960.”<sup><span href="#/chapter112a#mm_ch2_1" id="nn_ch2_1" title="Link target outside of Sample">1</span></sup> </p>
<p class="tx" id="pAYPI">
Coincidence? Mysterious stranger? Or angel? My files are bulging with stories like
this, and many of them appear for the first time in print in this book. Some of these
mysterious strangers are undoubtedly ordinary humans who showed up at just the right
time in the providence of God. But I believe that others are angels, for the Bible
speaks openly of their reality and activity in our world. Hebrews 13:2 says, “Do
not forget to entertain strangers, for by so doing some people have entertained
angels without knowing it.” </p>
<p class="tx" id="pAWK">
This book represents a long-term effort on my part to understand the subject of angels
in the teachings of the Bible and the story of Christ, in Christian and missionary
history, and in everyday life. I’m not a speculator or enthusiast. I’m a Bible teacher
devoted to “rightly dividing” the Word of God (2 Timothy 2:15 <span class="small">NKJV</span>). There’s no need
to be fanciful or fanatical on this subject, for the Bible provides enough solid
data for a satisfying understanding of these mysterious creatures. I’m not sure
I’ve ever seen an angel, but I’m not sure I haven’t. In these pages, I want to show
you from Scripture <span id="A5Y8">and from a handful of first-person accounts what God’s angels
do—and what they do for us. As the hymnist said: </span></p>
<p class="tx" id="pAcT9">
“All night, all day. Angels watching over me, my Lord.” </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?374617ed